export const BridgeIcon = (props: React.ComponentProps<'svg'>) => {
  return (
    <svg
      width="102"
      height="102"
      viewBox="0 0 102 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_b_1794_2508)">
        <rect
          width="102"
          height="102"
          rx="12.5446"
          fill="white"
          fillOpacity="0.1"
        />
        <path
          d="M83.8787 75.5001H83.0302V68.288C83.0302 67.0153 82.0757 65.9547 80.803 65.8486V33.8183H81.5454C82.3939 33.6062 83.0302 32.7577 83.0302 31.8031V29.3638C83.0302 28.1971 82.0757 27.3486 81.0151 27.3486H78.5757V25.4395C78.5757 24.8031 78.0454 24.3789 77.5151 24.3789C76.8787 24.3789 76.4545 24.8031 76.4545 25.4395V27.4547H73.0605C71.8939 27.4547 71.0454 28.4092 71.0454 29.4698V31.9092C71.0454 33.0759 71.9999 33.9244 73.0605 33.9244H73.3787V37.9547C68.606 41.1365 60.1212 43.1516 50.7878 43.1516C41.5605 43.1516 32.9696 41.1365 28.303 38.0607V34.0304H28.6212C29.7878 34.0304 30.6363 33.0759 30.6363 32.0153V29.5759C30.6363 28.4092 29.6818 27.5607 28.6212 27.5607H25.2272V25.4395C25.2272 24.8031 24.803 24.3789 24.1666 24.3789C23.5302 24.3789 23.106 24.8031 23.106 25.4395V27.4547H20.6666C19.4999 27.4547 18.6515 28.4092 18.6515 29.4698V31.9092C18.6515 32.9698 19.4999 33.9244 20.6666 33.9244H20.9848V65.9547C19.9242 66.1668 19.0757 67.1213 19.0757 68.288V75.5001H18.1212C17.4848 75.5001 17.0605 76.0304 17.0605 76.5607C17.0605 77.1971 17.4848 77.6213 18.1212 77.6213H31.3787C32.0151 77.6213 32.4393 77.1971 32.4393 76.5607C32.4393 76.0304 32.0151 75.5001 31.3787 75.5001H30.5302V68.288C30.5302 67.0153 29.5757 65.9547 28.303 65.8486V60.6516H73.3787V65.8486C72.3181 66.0607 71.4696 67.0153 71.4696 68.1819V75.3941H70.5151C69.9848 75.3941 69.4545 75.9244 69.4545 76.4547C69.4545 77.091 69.9848 77.5153 70.5151 77.5153H83.8787C84.5151 77.5153 84.9393 77.091 84.9393 76.4547C84.9393 76.0304 84.5151 75.5001 83.8787 75.5001ZM30.6363 58.6365H28.303V40.3941C29.0454 40.8183 29.7878 41.2425 30.6363 41.5607V58.6365ZM36.9999 58.6365H32.8636V42.4092C34.1363 42.8335 35.5151 43.2577 36.9999 43.5759V58.6365ZM43.2575 58.6365H39.1212V44.1062L43.2575 44.7425V58.6365ZM49.5151 58.6365H45.3787V44.9547C46.7575 45.0607 48.1363 45.1668 49.5151 45.1668V58.6365ZM55.7727 58.6365H51.6363V45.1668C53.0151 45.1668 54.3939 45.0607 55.7727 44.9547V58.6365ZM62.0302 58.6365H57.8939V44.7425C59.2727 44.6365 60.7575 44.4244 62.0302 44.1062V58.6365ZM68.3939 58.6365H64.2575V43.788C65.7424 43.4698 67.1212 43.0456 68.3939 42.6213V58.6365ZM73.3787 58.6365H70.5151V41.7728C71.5757 41.3486 72.5302 40.8183 73.3787 40.3941V58.6365Z"
          fill="white"
        />
        <rect
          x="0.418153"
          y="0.418153"
          width="101.164"
          height="101.164"
          rx="12.1264"
          stroke="url(#paint0_linear_1794_2508)"
          strokeWidth="0.836306"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_1794_2508"
          x="-21.744"
          y="-21.744"
          width="145.488"
          height="145.488"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="10.872" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1794_2508"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1794_2508"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1794_2508"
          x1="9.12934"
          y1="-9.36905e-07"
          x2="55.009"
          y2="61.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
